<div class="tw-flex tw-flex-row tw-items-center tw-space-x-10 tw-bg-white tw-p-12.5">
  <ia-icons name="circle_xmark" color="#e64444" class="tw-flex tw-size-15 tw-items-center" />
  <div class="tw-text-base">
    {{ error.message }}
  </div>
</div>

@if ({ isLoading: successionFacade.customerInformationIsLoading$ | async }; as vm) {
  <div class="tw-mt-6 tw-flex tw-justify-between">
    @if (error.buttons.buttonBack) {
      <button
        (click)="successionFacade.goBack()"
        iaButton
        type="button"
        id="btn-error-back"
        data-test-id="btn-error-back"
        variant="secondary"
        [disabled]="!!vm.isLoading"
        [isProcessing]="!!vm.isLoading"
      >
        {{ error.buttons.buttonBack.title }}
      </button>
    }

    @if (error.buttons.buttonTryAgain) {
      <button
        (click)="successionFacade.reloadPage()"
        iaButton
        type="button"
        id="btn-error-try-again"
        data-test-id="btn-error-try-again"
        variant="primary"
        [disabled]="!!vm.isLoading"
        [isProcessing]="!!vm.isLoading"
      >
        {{ error.buttons.buttonTryAgain.title }}
      </button>
    }
  </div>
}
